import * as angular from "angular";

let FeedbackController = {
    selector: "vcFeedback",
    templateUrl: "/angular/components/cancel/feedback.component.html",
    bindings: {
        feedback: "=",
        noun: "=",
        textareaLabel: "=?",
        submitFn: "&",
    },
    controller: class FeedbackController {
        // * bindings for typescript compiler *
        public feedback: any;
        public noun: any;
        public textareaLabel?: any;
        public submitFn: any;
        // ************************************

        $onInit() {
            this.textareaLabel = angular.isDefined(this.textareaLabel)
                ? this.textareaLabel
                : "Tell us how we could improve";
        }
    },
};

angular
    .module("cancel")
    .component(FeedbackController.selector, FeedbackController);
